import React, { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import ProductImage from './ProductImage';

export function ProductGallery({ images, alt }) {
	const [nav1, setNav1] = useState(null);
	const [nav2, setNav2] = useState(null);
	const slider1Ref = useRef(null);
	const slider2Ref = useRef(null);

	useEffect(() => {
		setNav1(slider1Ref.current);
		setNav2(slider2Ref.current);
	}, []);
	return (
		<div className="product-info-gallery-wrap prod-bottom">
			<div className="product-gallery-info-inner">
				{images.length > 1 &&
					<div className="product-gallery-thumb-row">
						<Slider
							asNavFor={nav1}
							ref={slider2Ref}
							slidesToShow={1}
							swipeToSlide={true}
							arrows={true}
							infinite={false}
							focusOnSelect={true}
							responsive={[
								{
									breakpoint: 900,
									slider: {
										arrows: true,
										slidesToShow: 1,
									},
								},
								{
									breakpoint: 500,
									settings: {
										arrows: false,
										slidesToShow: 2,
									},
								},
								{
									breakpoint: 400,
									settings: {
										arrows: false,
										slidesToShow: 1,
									},
								},
							]}
						>
							{images.map((item, index) => (
								<div key={index} className="product-gallery-thumb-column">
									<ProductImage
										photo={item.mediaItem.previewsrc}
										photoAlt={item.mediaItem.altText ?? alt}
										styles={''}
									/>

									{/* <img
									src={item.mediaItem.previewsrc}
									alt={item.mediaItem.altText}
								/> */}
								</div>
							))}
						</Slider>
					</div>
				}

				<div className="product-gallery-slider-img-wrap">
					<Slider
						asNavFor={nav2}
						ref={slider1Ref}
						className="product-gallery-container"
						fade={true}
						responsive={[
							{
								breakpoint: 900,
								settings: {
									arrows: false,
									slidesToShow: 1,
									dots: true,
								},
							},
						]}
					>
						{images.map((item, index) => (
							<div className="product-gallery-slide" key={index}>
								<div className="product-gallery-image-wrap">
									<ProductImage
										photo={item.mediaItem.previewsrc}
										photoAlt={item.mediaItem.altText ?? alt}
										styles={''}
									/>
								</div>
								<div className="product-gallery-caption-container">
									<p className="product-gallery-caption">
										Image may not depict the actual color selected
									</p>
								</div>
							</div>
						))}
					</Slider>
				</div>
			</div>
		</div>
	);
}

ProductGallery.propTypes = {
	images: PropTypes.arrayOf(
		PropTypes.shape({
			mediaItem: PropTypes.shape({
				previewsrc: PropTypes.string,
				altText: PropTypes.string,
			}),
		})
	),
	alt: PropTypes.string
};

export default ProductGallery;
